import {
  ArticleRequestWidget,
  LeaveApprovalWidget,
  PickingReleaseWidget,
  PoolReleaseWidget,
  TripApprovalWidget,
} from './ApprovalWidgets';
import { DueMaintenanceWidget } from './DueMaintenanceWidget';
import { KpiWidget } from './KpiWidget';
import { MyAssemblyWidget } from './MyAssemblyWidget';
import { MyQmWidget } from './MyQmWidget';
import { MyTasksWidget } from './MyTasksWidget';
import { NotificationsWidget } from './NotificationsWidget';
import { OverdueInvoicesWidget } from './OverdueInvoicesWidget';
import { ProjectHealthWidget } from './ProjectHealthWidget';
import { RevenueWidget } from './RevenueWidget';
import { TransportsTodayWidget } from './TransportsTodayWidget';
import type { DashboardWidgetDef } from './types';

/**
 * Registry aller Dashboard-Widgets (ADR 0062). Reihenfolge = Standard-Anordnung des
 * festen Dashboards; in Phase 3 wird sie pro Nutzer über ein gespeichertes Layout
 * überschrieben. Jedes Widget deklariert seine Berechtigung — die Seite rendert nur
 * die erlaubten. Finanz-Widgets hängen an `dashboard.viewfinancials`.
 */
export const DASHBOARD_WIDGETS: DashboardWidgetDef[] = [
  {
    id: 'meine-aufgaben',
    title: 'Meine offenen Aufgaben',
    requiredPermission: 'projects.read',
    size: 'full',
    Component: MyTasksWidget,
  },
  {
    id: 'meine-montage',
    title: 'Meine Montage-Einsätze',
    requiredPermission: 'assembly.read',
    size: 'half',
    Component: MyAssemblyWidget,
  },
  { id: 'kennzahlen', title: 'Kennzahlen', size: 'full', Component: KpiWidget },
  {
    id: 'transporte-heute',
    title: 'Transporte heute',
    requiredPermission: 'transport.read',
    size: 'half',
    Component: TransportsTodayWidget,
  },
  {
    id: 'kommissionierung-freigabe',
    title: 'Kommissionierung: Freigabe',
    requiredPermission: 'commissioning.release',
    size: 'half',
    Component: PickingReleaseWidget,
  },
  {
    id: 'bestellpool-freigabe',
    title: 'Bestellpool: Freigabe',
    requiredPermission: 'procurement.update',
    size: 'half',
    Component: PoolReleaseWidget,
  },
  {
    id: 'artikelnummern-freigabe',
    title: 'Artikel-Anträge: Freigabe',
    requiredPermission: 'engineering.approve',
    size: 'half',
    Component: ArticleRequestWidget,
  },
  {
    id: 'urlaub-genehmigung',
    title: 'Urlaub: Genehmigung',
    requiredPermission: 'leave.manage',
    size: 'half',
    Component: LeaveApprovalWidget,
  },
  {
    id: 'reise-genehmigung',
    title: 'Reisen: Genehmigung',
    requiredPermission: 'travel.manage',
    size: 'half',
    Component: TripApprovalWidget,
  },
  {
    id: 'meine-qm',
    title: 'Meine QM-Prozesse',
    requiredPermission: 'qm.read',
    size: 'half',
    Component: MyQmWidget,
  },
  { id: 'benachrichtigungen', title: 'Benachrichtigungen', size: 'half', Component: NotificationsWidget },
  {
    id: 'umsatzverlauf',
    title: 'Umsatzverlauf',
    requiredPermission: 'dashboard.viewfinancials',
    size: 'full',
    Component: RevenueWidget,
  },
  {
    id: 'projektgesundheit',
    title: 'Projektgesundheit',
    requiredPermission: 'projects.read',
    size: 'full',
    Component: ProjectHealthWidget,
  },
  {
    id: 'ueberfaellige-rechnungen',
    title: 'Überfällige Rechnungen',
    requiredPermission: 'dashboard.viewfinancials',
    size: 'half',
    Component: OverdueInvoicesWidget,
  },
  {
    id: 'faellige-wartungen',
    title: 'Fällige Wartungen',
    requiredPermission: 'assembly.read',
    size: 'half',
    Component: DueMaintenanceWidget,
  },
];
